import { jsx as _jsx } from "react/jsx-runtime";
import Grid from '../Grid';
/**
 * @deprecated Use MUI `Grid` component from `@hbf/dsl` instead.
 */
const Col = ({ children, ...rest }) => (_jsx(Grid, { ...rest, item: true, container: false, children: children }));
export { Col };
